module.exports = __webpack_public_path__ + "img/icon_comma@3x.b2d1ad81.png";